<mat-toolbar color="primary">
  <span id="spørreundersøkelse-besvarelse-dialog-tittel">
      {{ "Besvar spørreundersøkelsen {tittel}"|translate: {tittel:spoerreundersoekelse().tittel} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@switch (modus()) {
  @case ('skjema') {
    <div class="tips-under-toolbar">
      <tips>
        {{ 'Du kan endre besvarelse din helt til spørreundersøkelsen lukkes {dato}'|translate:{dato: spoerreundersoekelse().responsperiode!.slutt|zoneddatetimeSomPlaindate|plaindate} }}
      </tips>
    </div>
    <form [formGroup]="skjema" (ngSubmit)="registrer()">
      <mat-dialog-content #skjemaKontainer>
          <spoerreundersoekelse-besvarelse-skjema [skjemakontroll]="skjema"/>
      </mat-dialog-content>
      <mat-dialog-actions>
        <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{'Scroll ned for å se resten av spørreskjemaet...' | translate}}</span></div>
        <div class="handlinger">
          <div class="venstre"></div>
          <div class="senter">
          <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
          <submit-button [arbeidPaagaar]="lagrer()" [skjema]="skjema" spinnerTekst="{{'Registrerer...'|translate}}" data-testid="registrer-knapp">
            {{ 'Registrer besvarelse'|translate }}
          </submit-button>
          </div>
          <div (click)="gaaTilFoersteUbesvarte()" class="høyre">
            @if(antallUbesvarteSpoersmaal()> 0){
              {{ '{antall} spørsmål mangler svar'|translate:{antall:antallUbesvarteSpoersmaal()} }},
              <a>{{'gå til første ubesvarte'|translate}}</a>
            }
          </div>
        </div>
      </mat-dialog-actions>
    </form>
  }
  @case ('kvittering') {
    <mat-dialog-content class="kvittering" data-testid="kvittering">
      <h2>{{ 'Takk for at du besvarte spørreundersøkelsen'|translate }}</h2>
      <p>{{ 'Du kan oppdatere din besvarelse til og med {dato}'|translate:{dato: spoerreundersoekelse().responsperiode!.slutt|zoneddatetimeSomPlaindate|plaindate} }}</p>
      <mat-icon>celebration</mat-icon>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
  @case ('stengt') {
    <mat-dialog-content class="stengt" data-testid="stengt">
      <p>{{ 'Spørreundersøkelsen er stengt og kan derfor ikke besvares.'|translate }}</p>
      <p>
        {{ 'Du finner resultatene fra spørreundersøkelsen under grupper > {gruppenavn} i {organisasjonsnavn} > spørreundersøkelser'|translate:{gruppenavn:gruppe()?.tittel, organisasjonsnavn:gruppe()?.organisasjonsnavn} }}, <br>
        <a (click)="visResultater()">{{ 'klikk her for å gå dit'|translate }}.</a>
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="avbryt()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
}
